class UserSession {
  constructor() {
    this.user = null;
    this.language = localStorage.getItem("i18nextLng");
  }

  saveSessionCred(userInfo) {
    this.user = userInfo;
    localStorage.setItem("authSession", JSON.stringify(this.user));
  }

  get getLanguage() {
    const lan = localStorage.getItem("i18nextLng");
    this.language = lan;
    return lan;
  }

  clearSessionCred() {
    this.user = null;
    localStorage.removeItem("authSession");
  }

  get getSessionCred() {
    const user = localStorage.getItem("authSession");
    if (user) {
      this.user = JSON.parse(user);
    }
    return this.user;
  }
}

const Session = new UserSession();
export default Session;
